import {
  Component,
  Directive,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[tooltip]'
})
export class TooltipDirective implements OnDestroy, OnChanges {
  @Input() tooltipContent: string = '';
  @Input() tooltipPosition: 'left' | 'bottom' | 'top' | 'right' = 'top';
  tooltip?: HTMLElement;
  isMouseOver = false;
  event?: any;

  constructor() {}

  ngOnDestroy() {
    this.destroyTooltip();
    this.isMouseOver = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tooltipContent']) {
      this.destroyTooltip();
      if (this.event) {
        this.onMouseEnter(this.event);
      }
    }
  }

  @HostListener('mouseenter', ['$event.target']) onMouseEnter($event: any) {
    if (!this.tooltip && this.tooltipContent != '' && this.isMouseOver) {
      this.event = $event;
      this.tooltip = document.createElement('div');
      this.tooltip.innerHTML = this.tooltipContent;
      this.tooltip.classList.add('tooltip');
      this.tooltip.classList.add(this.tooltipPosition);
      this.tooltip = document.body.appendChild(this.tooltip);
      const tClient = $event.getBoundingClientRect();
      if (this.tooltipPosition == 'left') {
        const tLeft = tClient.left - this.tooltip.clientWidth - 10;
        const tTop =
          tClient.top + tClient.height / 2 - this.tooltip.clientHeight / 2;
        this.tooltip.style.top = tTop + 'px';
        this.tooltip.style.left = tLeft + 'px';
      }
      if (this.tooltipPosition == 'top') {
        const tLeft =
          tClient.left + tClient.width / 2 - this.tooltip.clientWidth / 2;
        const tTop = tClient.top - this.tooltip.clientHeight - 10;
        this.tooltip.style.top = tTop + 'px';
        this.tooltip.style.left = tLeft + 'px';
      }
      if (this.tooltipPosition == 'bottom') {
        const tLeft =
          tClient.left + tClient.width / 2 - this.tooltip.clientWidth / 2;
        const tBottom = tClient.bottom;
        this.tooltip.style.top = tBottom + 'px';
        this.tooltip.style.left = tLeft + 'px';
      }
      if (this.tooltipPosition == 'right') {
        const tRight = tClient.left + tClient.width + 10;
        const tTop =
          tClient.top + tClient.height / 2 - this.tooltip.clientHeight / 2;
        this.tooltip.style.top = tTop + 'px';
        this.tooltip.style.left = tRight + 'px';
      }
    }
  }

  destroyTooltip() {
    if (this.tooltip) {
      this.tooltip.remove();
      this.tooltip = undefined;
    }
  }

  @HostListener('mouseover', ['$event']) onMouseOver($event: any) {
    this.isMouseOver = true;
  }

  @HostListener('mouseleave', ['$event']) onMouseLeave($event: any) {
    this.destroyTooltip();
    this.isMouseOver = false;
  }
}
